<template>
    <div>
        <ul class="step-title">
            <li :class="{on: currentPath == '/deliver/cert'}">상품권인증</li>
            <li :class="{on: currentPath == '/deliver/register'}">배송지입력</li>
            <li :class="{on: currentPath == '/deliver/request'}">배송정보확인</li>
        </ul>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Stepper',
  data(){
      return {
        currentPath : ''
      }
  },
  created(){
      this.currentPath = this.$route.path;
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Stepper.vue